export function sanitizeLicensePlateNumber(prevLicensePlateNumber: string, updateLicensePlateNumber?: string): string {
  if (updateLicensePlateNumber !== undefined) {
    return updateLicensePlateNumber.replace(/\s+/g, '');
  }
  return prevLicensePlateNumber;
}
